import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

const initialState = {
    categoryStatus: null,
    productStatus: null,
    categoryData: null,
    productData: null,
    categorySyncSuccess: null,
    productSyncSuccess: null,
    syncError: null
}


export const syncCategory = createAsyncThunk("syncCategory", async (storeHash) => {
    try {
        let request = { storeDomain: storeHash };
        const response = await fetch(`/api/syncCategory`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request)
        })
        if (!response.ok) {
            throw new Error('Failed to sync category');
        }
        return await response.json();
        // return response;
    } catch (error) {
        throw new Error('Failed to sync category', error);
    }
});

export const syncProduct = createAsyncThunk("syncProduct", async (storeHash) => {
    try {
        let request = { storeDomain: storeHash };
        const response = await fetch(`/api/syncProduct`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request)
        })
        if (!response.ok) {
            throw new Error('Failed to sync product');
        }
        return await response.json();
        // return response;
    } catch (error) {
        throw new Error('Failed to sync product', error);
    }
});

const syncSlice = createSlice({
    name: "syncData",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(syncCategory.pending, (state) => {
            state.categoryStatus = "Category Sync Inprogress"
            state.categorySyncSuccess = null;
            state.syncError = null;
        });
        builder.addCase(syncCategory.fulfilled, (state, action) => {
            let status = JSON.parse(action.payload.data);
            // let status = action.payload.data;
            if (status.SUCCESS !== "") {
                state.categorySyncSuccess = status.SUCCESS
                state.syncError = null
            } else if (status.ERROR !== "") {
                state.syncError = status.ERROR
            }
            state.categoryStatus = "Category Sync Completed"
            state.categoryData = "completed"
        });
        builder.addCase(syncCategory.rejected, (state) => {
            state.categoryStatus = "Category Sync Failed"
        });
        builder.addCase(syncProduct.pending, (state) => {
            state.productStatus = "Product Sync Inprogress"
            state.productSyncSuccess = null;
            state.syncError = null;
        });
        builder.addCase(syncProduct.fulfilled, (state, action) => {
            let status = JSON.parse(action.payload.data);
            // let status = action.payload.data;
            if (status.SUCCESS !== "") {
                state.productSyncSuccess = status.SUCCESS
                state.syncError = null
            } else if (status.ERROR !== "") {
                state.syncError = status.ERROR
            }
            state.productStatus = "Product Sync Completed"
            state.productData = "completed"
        });
        builder.addCase(syncProduct.rejected, (state) => {
            state.productStatus = "Product Sync Failed"
        });
    }
})

export default syncSlice.reducer